<template>
  <div class="intro-section mb-5">
    <v-container fluid class="mb-0 pt-5">
      <div class='d-flex justify-space-between align-center flex-wrap'>
        <h2 class='mr-5'>BOOK PARKERING</h2>
        <v-chip color='primary' link href='/book-parking' target='_blank'>
          <v-icon left size='20'>
            mdi-open-in-new
          </v-icon>
          Eksternt link
        </v-chip>
      </div>
    </v-container>
    <v-container fluid class="py-5 px-lg-10">
      <v-row align="center" class="my-0">
        <v-col cols="12" md="4" class="py-0">
          <v-text-field v-model="licensePlate" :loading='carInfoLoading' label="Nummerplade" @input='initGetCarInfo();resetSubmitButton();resetConfirmationMessage()' @keyup.enter="submitForm"/>
        </v-col>
        <v-col cols="12" md="4" class="py-0">
          <v-text-field v-model="mobilePhone" label="Mobiltelefon" @input='resetSubmitButton();resetConfirmationMessage()' @keyup.enter="submitForm"/>
        </v-col>
        <v-col cols="12" md="4" class="py-0">
          <v-menu ref="menuFrom" v-model="menuFrom" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field :value="formattedBookingDateTime" class="datepicker-input" append-icon="mdi-calendar" @click:append="menuFrom = true" label="Booking Dato" readonly v-on="on"/>
            </template>
            <v-date-picker v-model="bookingDateTime" :min="new Date().toISOString().split('T')[0]" no-title @change="menuFrom = false;resetSubmitButton();resetConfirmationMessage()" color="primary lighten-0"/>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="py-0">
          <v-alert v-if='carInfo' color="primary" outlined text>{{carInfo}}</v-alert>
          <v-alert v-else-if='licensePlate && !carInfo' color="primary" outlined text>Nummerpladen kan ikke findes</v-alert>
          <v-alert v-else-if='confirmationMessage' color="primary" type="success" class='white--text text-uppercase'>{{confirmationMessage}}</v-alert>
        </v-col>
      </v-row>
    </v-container>
    <div class="intro-section__bottom-box">
      <div class="d-flex justify-end flex-wrap align-center pa-5">
        <v-btn depressed class="ml-2 my-1" :color="submitButtonColor" :loading='submitLoading' :disabled='submitLoading || !mobilePhone || !bookingDateTime' @click="submitForm">
          Book
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import methods from '@/utils/methods';
  import api from '@/api/api';

  export default {
    name: 'ParkingForm',

    data: function () {
      return {
        licensePlate: '',
        mobilePhone: '',
        bookingDateTime: new Date().toISOString().split('T')[0],
        menuFrom: false,
        carInfo: null,
        carInfoLoading: false,
        submitLoading: false,
        submitButtonColor: 'primary',
        confirmationMessage: '',
        confirmationTimeout: null
      };
    },

    computed: {
      formattedBookingDateTime: function () {
        if (this.bookingDateTime) {
          return methods.formatDate(this.bookingDateTime);
        } else {
          return '';
        }
      },
    },

    methods: {
      clearForm: function () {
        this.licensePlate = '';
        this.mobilePhone = '';
        this.bookingDateTime = new Date().toISOString().split('T')[0];
        this.carInfo = null;
      },
      resetSubmitButton: function() {
        this.submitButtonColor = 'primary';
      },
      resetConfirmationMessage: function() {
        this.confirmationMessage = '';
        if (this.confirmationTimeout) {
          clearTimeout(this.confirmationTimeout);
          this.confirmationTimeout = null;
        }
      },
      initGetCarInfo: function() {
        this.carInfo = null;
        if (this.licensePlate.length >= 4) {
          this.getCarInfo();
        }
      },
      queryData: function() {
        const queryData = {};
        queryData.licensePlate = this.licensePlate.toUpperCase();
        queryData.mobilePhone = this.mobilePhone;
        queryData.bookingDateTime = this.bookingDateTime;
        return queryData;
      },
      submitForm: async function () {
        if (!this.mobilePhone || !this.bookingDateTime) return;
        // Clear any existing timeout
        if (this.confirmationTimeout) {
          clearTimeout(this.confirmationTimeout);
          this.confirmationTimeout = null;
        }
        try {
          this.submitLoading = true;
          await api.setInternalParkingBooking(this.queryData());
          this.confirmationMessage = `PARKERING FOR: ${this.licensePlate} ER BEKRÆFTET - TJEK SMS`;
          this.clearForm();
          this.confirmationTimeout = setTimeout(() => {
            this.resetConfirmationMessage();
          }, 15000);
          this.$emit('getParking');
        } catch (e) {
          this.submitButtonColor = 'error';
          if (e.response.status === 401 || e.response.status === 403) {
            methods.showGlobalSnackbar('error', 'Du kan desværre ikke bruge parkerings-appen. Din IP adresse er ikke whitelistet. Kontakt support@kirurgiklinik.dk hvis du har spørgsmål.');
          } else {
            methods.showGlobalSnackbar('error', methods.getErrors(e.response));
          }
        } finally {
          this.submitLoading = false;
        }
      },
      getCarInfo: async function () {
        try {
          this.carInfoLoading = true;
          const carData = await api.getCarInfo(this.licensePlate.toUpperCase());
          carData.data && (this.carInfo = carData.data);
        } catch (e) {
          this.carInfo = null;
        } finally {
          this.carInfoLoading = false;
        }
      }
    },
  };
</script>
